import { avatars } from '@shared/static/avatars';
import { DEFAULT_TEAM_SLUG } from '@utils/static';

export function Avatar({ team }) {
  const isDefault = team?.slug === DEFAULT_TEAM_SLUG;

  return (
    <div className="avatar-color" style={{ color: team?.avatar?.color }}>
      {isDefault ? avatars.default : avatars[team?.avatar?.name]}
    </div>
  );
}
